export const ActionTypes = {
    GET_DOCUMENT_BY_ID: "GET_DOCUMENT_BY_ID",
    GET_DOCUMENT_LIST: "GET_DOCUMENT_LIST",
    GET_AGENDA_LIST_FOR_DOCUMENT: "GET_AGENDA_LIST_FOR_DOCUMENT",
    GET_MEETING_LIST_FOR_DOCUMENT: "GET_MEETING_LIST_FOR_DOCUMENT",
    GET_MEETING_VIEWS: "GET_MEETING_VIEWS",
    ADD_MEETING_VIEWS: "ADD_MEETING_VIEWS",
    GET_LANDING_PAGE_DOCUMENT_BY_ID: "GET_LANDING_PAGE_DOCUMENT_BY_ID",
    GET_LANDING_PAGE_DOCUMENTS_LIST: "GET_LANDING_PAGE_DOCUMENTS_LIST",
    REMOVE_DOCUMENT_BY_ID: "REMOVE_DOCUMENT_BY_ID",
    RESET_STATE: 'RESET_STATE'
};
